var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeliveryNote = function SvgDeliveryNote(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M347.3 135.7h305.3c9.4 0 17-7.6 17-17V84.8c0-28.1-22.8-50.9-50.9-50.9h-60.2C546.5 13.2 524.3 0 500 0s-46.5 13.2-58.6 33.9h-60.2c-28.1 0-50.9 22.8-50.9 50.9v33.9c0 9.4 7.7 17 17 17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M814.2 78.2h-41.9c-11.6 0-21 9.4-21 21v41.9c0 34.7-28.2 62.8-62.8 62.8h-377c-34.7 0-62.8-28.2-62.8-62.8V99.2c0-11.6-9.4-21-21-21h-41.8c-34.7 0-62.8 28.2-62.8 62.8v796.1c0 34.7 28.2 62.8 62.8 62.8h628.4c34.7 0 62.8-28.2 62.8-62.8v-796c0-34.6-28.2-62.9-62.9-62.9m-271.7 629H310.7v-76.8h231.8zm95.6-192.5v43.6H310.7V482h327.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeliveryNote);
export default ForwardRef;